import { MetafieldRes } from '@magal/models'

const MAX_IMAGES_KEY = 'show_images_until'

export const getShowImagesUntilMetafield = (
  metafields: MetafieldRes[],
): number | null => {
  const metafield = metafields.find((mf) => mf?.key === MAX_IMAGES_KEY)

  return metafield ? parseInt(metafield.value) : null
}
